export default __webpack_public_path__ + "static/media/mdg-video.0e1fab87.m4v";